import * as React from 'react';

function SvgInfo(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 22.5a10.5 10.5 0 110-21 10.5 10.5 0 010 21zm0 1.5a12 12 0 100-24 12 12 0 000 24z" />
      <path d="M13.395 9.882l-3.435.43-.123.57.675.125c.44.105.528.264.432.704l-1.107 5.202c-.291 1.345.157 1.978 1.212 1.978.817 0 1.767-.378 2.197-.897l.132-.624c-.3.264-.738.369-1.029.369-.412 0-.562-.29-.456-.8l1.502-7.057zM13.5 6.75a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
    </svg>
  );
}

export default SvgInfo;
